// extracted by mini-css-extract-plugin
module.exports = {"Benefits":"BenefitsNew_Benefits__Qc0qX","efmodal":"BenefitsNew_efmodal__7qWAk"};